export enum CustomerType {
  PK = "pk",
  GK = "gk",
}

export const CustomerTypeLabel = {
  [CustomerType.PK]: "Privatkunde",
  [CustomerType.GK]: "Geschäftskunde",
};



// WEBPACK FOOTER //
// ./src/types/CustomerType.tsx